export default __webpack_public_path__ + "600ee39.png";